module.exports = __webpack_public_path__ + "img/blue2.3e7bbfad.jpg";